import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getCurrency: EvokeAction<AppState, AppActions> = async (store) => {
  try {
    const currency = await api.get(`currency/list`);
    await store.update((state) => {
      state.currency = currency;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const currencyActions = {
  getCurrency,
};
